// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".updated[data-v-02e8d5bb] {\n  font-size: small;\n  font-weight: 400;\n  font-style: italic;\n}\n.req-diclaimer[data-v-02e8d5bb] {\n  font-size: 0.8rem;\n  font-weight: 400;\n}", ""]);
// Exports
module.exports = exports;
